import { createFeatureSelector, createSelector } from '@ngrx/store';

import { EntityInfoPageKeyParams, toEntityInfoPageKey } from './entity-info-page-key';
import { EntityInfoPageState, StateName } from './entity-info-page.state';

export const selectInfoPageState = createFeatureSelector<EntityInfoPageState>(StateName);

export const selectInfoPageFilterText = (props: EntityInfoPageKeyParams) =>
  createSelector(selectInfoPageState,
    (state: EntityInfoPageState) => {
      const key = toEntityInfoPageKey(props);
      if (!state.keyed_entity_info_pages[key]) {
        return null;
      } else {
        return state.keyed_entity_info_pages[key].filterText;
      }
    });
